import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import "./fonts.css";
import { captureCampaignFromUrl } from "./utils/analytics.ts";

import HomeScreen from "./views/home.tsx";
import WatchList from "./views/watchlist.tsx";
import Otp from "./views/otp.tsx";
import SubscriptionPlan from "./views/subscriptionplan.tsx";
import Profile from "./views/profile.tsx";
import NotificationFiltersView from "./views/notificationFilters.tsx";
import AboutUs from "./views/about.tsx";
import RefundsPolicy from "./views/refunds.tsx";
import { withSubscriberContext } from "./hoc/withSubscriberContext.tsx";
import Disclaimer from "./views/disclaimer.tsx";
import Privacy from "./views/privacy.tsx";
import Terms from "./views/terms.tsx";
import News from "./views/news.tsx";
import NewsArticle from "./views/newsArticle.tsx";
import TelegramSignup from "./views/telegram.tsx";
const App = () => {
  useEffect(() => {
    captureCampaignFromUrl();
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <Switch>
          <Route component={HomeScreen} exact path="/" />
          <Route component={WatchList} path="/watch-list/:token?" />
          <Route component={Otp} exact path="/otp" />
          <Route component={SubscriptionPlan} path="/subscription-plans" />
          <Route component={AboutUs} path="/about-us" />
          <Route component={NewsArticle} path="/news/:slug" />
          <Route component={News} exact path="/news" />
          <Route component={RefundsPolicy} path="/refunds-policy" />
          <Route component={Disclaimer} path="/disclaimer" />
          <Route component={Terms} path="/terms" />
          <Route component={Privacy} path="/privacy" />
          <Route component={Profile} path="/profile" />
          <Route component={NotificationFiltersView} path="/notification-filters" />
          <Route component={TelegramSignup} exact path="/telegram" />
          <Redirect to="**" />
        </Switch>
      </Router>
    </HelmetProvider>
  );
};

export default withSubscriberContext(App);